import { defineComponent as v, computed as o, useAttrs as k, createElementBlock as B, createBlock as h, openBlock as l, mergeProps as a, toHandlers as u, unref as n, renderSlot as p, resolveDynamicComponent as y, withCtx as C } from "vue";
import { useTrackedListeners as b } from "../../composables/useTrackedListeners.js";
import { useRouterLinkComponent as R } from "@ds/plugin";
import { omit as _ } from "../../utils/omit.js";
const L = ["type"], E = /* @__PURE__ */ v({
  name: "RevButtonBase",
  inheritAttrs: !1,
  __name: "ButtonBase",
  props: {
    replace: { type: Boolean },
    to: {},
    prefetch: { type: Boolean },
    tracking: {},
    rel: {}
  },
  setup(c) {
    const r = c, i = R(), e = o(() => _(k(), ["onClick", "onMouseover"])), { listeners: s } = b(r), m = o(() => !r.to && !e.value.href), f = o(() => e.value.disabled === !0), d = o(() => r.rel ? `${r.rel} noreferrer noopener` : "noreferrer noopener");
    return (t, $) => m.value ? (l(), B("button", a({ key: 0 }, e.value, {
      type: e.value.type || "button"
    }, u(n(s), !0)), [
      p(t.$slots, "default")
    ], 16, L)) : (l(), h(y(n(i)), a(
      { key: 1 },
      f.value ? {
        ...e.value,
        "aria-disabled": !0
      } : {
        ...e.value,
        to: t.to
      },
      {
        prefetch: t.prefetch,
        rel: d.value,
        replace: t.replace
      },
      u(n(s))
    ), {
      default: C(() => [
        p(t.$slots, "default")
      ]),
      _: 3
    }, 16, ["prefetch", "rel", "replace"]));
  }
});
export {
  E as default
};
